import { ApiWithToken } from "../axios-instance";

export const passwordService = {
  forgotPassword: async (email: string) =>
    ApiWithToken.post("api/authentication/password-reset/?is_aula=true", {
      email: email,
    }),
  resetPassword: async (password: string, uid: string, token: string) =>
    ApiWithToken.post(
      `api/authentication/password-reset/confirm/${uid}/${token}/`,
      {
        password: password,
      }
    ),
};
